<template>
  <section
    class="cookie-policy"
    :class="{ animation: isAccepted }"
    v-if="show && !isAccepted"
  >
    <transition name="toggleContent" mode="out-in">
      <div
        key="1"
        class="flex between al-center cookie-content"
        v-if="!costumActive"
      >
        <p class="font-14 f-roman">
          {{ _.get(getINDX, 'title') }}
        </p>
        <div class="flex al-center buttons">
          <div class="accept f-bold pointer" @click="acceptCookies()">
            {{ _.get(getINDX, 'accept.title') }}
          </div>
          <div class="costumize f-bold pointer" @click="costumize()">
            {{ _.get(getINDX, 'customize.title') }}
          </div>
          <span @click="closeCookie">
            <IconComponent class="pointer" name="close" />
          </span>
        </div>
      </div>
      <div key="2" class="costumize-cookies" v-else>
        <div class="flex">
          <div class="costumize-content">
            <p class="warning font-14 f-bold">
              {{ _.get(getINDX, 'desc') }}
            </p>
            <div class="flex costumize-content-open">
              <div class="flex options">
                <template>
                  <div class="costumize-item">
                    <h4 class="font-14 f-bold">{{ _.get(getINDX, 'title1') }}</h4>
                    <p class="font-14 f-roman">
                      {{ _.get(getINDX, 'strictly_necessary') }}
                    </p>

                    <Toggler
                      :status="item1"
                      :class="{ 'not-allowed': item1}"
                      @click="item1 = !item1"
                    />
                  </div>
                </template>
                <template>
                  <div class="costumize-item">
                    <h4 class="font-14 f-bold">{{ _.get(getINDX, 'title2') }}</h4>
                    <p class="font-14 f-roman">
                      {{ _.get(getINDX, 'performance') }}
                    </p>

                     <Toggler
                      :status="item2"
                      :class="{ 'not-allowed': item2}"
                      @click="item2 = !item2"
                    />
                  </div>
                </template>
                <template>
                  <div class="costumize-item">
                    <h4 class="font-14 f-bold">{{ _.get(getINDX, 'title3') }}</h4>
                    <p class="font-14 f-roman">
                      {{ _.get(getINDX, 'advertising') }}
                    </p>

                    <Toggler
                      :status="item3"
                      :class="{ 'not-allowed': item3 }"
                      @click="item3 = !item3"
                    />
                  </div>
                </template>
              </div>

              <div class="costumize-buttons">
                <div class="accept f-bold pointer" @click="acceptCookies()">
                  {{ $fn.tr("Accept") }}
                </div>
                <div class="cancel f-bold pointer" @click="costumize()">
                  {{ $fn.tr("cancel") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>
<script>
import IconComponent from "@/components/IconComponent";
import Toggler from "./Toggler.vue";
export default {
  components: {
    IconComponent,
    Toggler
  },
  data() {
    return {
      item1: false,
      item2: false,
      item3: false,
      show: true,
      isAccepted: false,
      costumActive: false,
    };
  },
  watch: {
    localStorageStatus: {
      immediate: true,
      handler(val) {
        this.isAccepted = val;
      }
    }
  },
  computed: {
    getINDX() {
      return _.get(this.$store.state.main.indx, 'widgets.cookie')
    },
    localStorageStatus() {
      return typeof localStorage.getItem("acceptCookies") === "string" &&
        localStorage.getItem("acceptCookies") !== "undefined"
        ? JSON.parse(localStorage.getItem("acceptCookies"))
        : false;
    }
  },
  methods: {
    closeCookie() {
      this.show = !this.show;
    },
    costumize() {
      this.costumActive = !this.costumActive;
    },
    acceptCookies() {
      localStorage.setItem("acceptCookies", true);
      this.isAccepted = true;
    }
  }
};
</script>
